import { useMemo } from 'react';
import { Tags } from '../../models';

export const useIsFound = (currentTags: string = '') => {
  return useMemo(() => {
    return currentTags
      ?.split(',')
      .map((t) => t.trim())
      .includes(Tags.FOUND);
  }, [currentTags]);
};
